import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=65ca6849&"
import script from "./MaintenancePage.vue?vue&type=script&lang=js&"
export * from "./MaintenancePage.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports